module.exports = __webpack_public_path__ + "media/images/roundSummary__titleDeco-b6907b1ba8b6c85769d2089807ef68f9.jpg";